<div *ngIf="!iframeEmbedded">
  <nav class="navbar navbar-expand-lg navbar-dark bg-lavendar py-0 justify-content-between fixed-top">
    <div class="w-100 d-flex nav-lg-holder">
      <div class="navbar-brand me-1">
        <span class="pe-2 d-inline-block">
          <a href="https://www.kairhos.com/" target="_blank">
            <img src="../../../../assets/images/logo.svg" class="img-header cursor-pointer img-size" width="100" />
          </a>
        </span>
        <span class="ps-2 border-left-nav d-inline-block">
          <a href="/" class="text-decoration-none">
            <img src="../../../../assets/images/rubinIcon.png" class="keplerLogo img-size" />
          </a>
        </span>
      </div>
      <!--Desktop-->
      <div class="collapse navbar-collapse d-none d-sm-none d-md-none d-lg-none d-xl-block ms-2 hsace"
        *ngIf="authenticated">
        <div class="d-flex" style="width: 100%" [ngClass]="{ 'justify-content-center': !user.is_vendor }">
          <ul class="navbar-nav d-flex align-items-center menu-nav" [ngStyle]="{ flex: !user.is_vendor ? 'auto' : '' }">
            <li class="nav-item d-flex justify-content-between align-items-center border-left-nav">
              <span class="nav-link" (click)="navigateToHome()">
                <img src="../../../../assets/images/header/home.svg" alt="image" width="18" />
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="d-flex align-items-centered d-none d-sm-none d-md-none d-lg-block d-xl-block hsace" id="login">
        <ul class="navbar-nav d-flex align-items-center">
          <li class="nav-item licence-notice" *ngIf="licenceNotice?.show"
            [ngClass]="'licence-notice--' + licenceNotice?.state" [matTooltip]="licenceNotice?.message ?? ''"
            matTooltipClass="example-tooltip">
            <mat-icon aria-hidden="true" class="licence-notice__icon">warning</mat-icon>
            <span class="licence-notice__text">{{ licenceNotice?.message }}</span>
          </li>
          <li class="nav-item" matTooltip="Action Central" matTooltipClass="example-tooltip"
            *ngIf="!this.user?.is_vendor">
            <img src="../../../../assets/images/action-central.svg" class="action-tracker-ico"
              style="margin-top: 1px;margin-right:-6px;" (click)="navigateTo('actiontracker')" />
          </li>
          <li class="nav-item" matTooltip="Parade" matTooltipClass="example-tooltip" (click)="navigateTo('parade')">
            <mat-icon class="project-central-ico" style="width: 20px !important; color: #d1fdf4 !important">
              control_camera
            </mat-icon>
          </li>
          <li class="nav-item" [matTooltip]="menuText.mainMenu7" matTooltipClass="example-tooltip"
            (click)="navigateTo('prism/ipdb')" *ngIf="!this.user?.is_vendor">
            <img src="assets/Icons/ipdb.svg" width="15px" alt="image" />
          </li>

          <li class="nav-item" style="justify-content: center" matTooltip="Injest.IQ" matTooltipClass="example-tooltip"
            *ngIf="isSuperAdmin" (click)="openInjestIQ()">
            <img src="/assets/Icons/injest-iq.svg" height="22px" class="cursor-pointer" />
          </li>
          <li class="nav-item" style="justify-content: center" [matTooltip]="airoLinkLocked ? 'Airo is not included in your licence' : 'Airo'" matTooltipClass="example-tooltip"
            [class.airo-locked]="airoLinkLocked"
            *ngIf="!this.user?.is_vendor" (click)="openAiro()">
            <img src="/assets/Icons/airoIcon.png" height="23px" class="airo-ico" />
            <mat-icon *ngIf="airoLinkLocked" class="airo-lock">lock</mat-icon>
          </li>
          <li class="nav-item" *ngIf="authenticated && !this.user?.is_vendor">
            <span class="p-1 notification-Status bg-danger border border-light rounded-circle"
              *ngIf="hasNotification"></span>
            <mat-icon aria-hidden="false" aria-label="material-icons-filled" class="cursor-pointer"
              id="notificationbell" [matMenuTriggerFor]="notificationmenu" style="color: #d1fdf4 !important">
              notifications
            </mat-icon>
          </li>
          <li matTooltip="Show Tags">
            <mat-slide-toggle class="tags-toggle" (change)="toggleTag($event)" [checked]="isChecked"></mat-slide-toggle>
          </li>
          <li class="nav-item dropdown d-flex flex-row align-items-center"
            (click)="showProfilePopUp = !showProfilePopUp" id="profile" *ngIf="authenticated">
            <ngx-avatar class="text-truncate" matTooltip="{{ user?.full_name }}" matTooltipClass="example-tooltip"
              [style]="customStyle" size="40" [name]="user?.full_name ? user?.full_name : user?.email">
            </ngx-avatar>
            <mat-icon aria-label="material-icons-filled " class="cursor-pointer fs-5 ms-2 mt-2">
              expand_more
            </mat-icon>
          </li>
          <li>
            <a class="btn d-flex p-0" style="align-items: center" *ngIf="!authenticated"
              (click)="showLoginPopUp = !showLoginPopUp">
              <img src="../../../../assets/images/logout_trans.png" class="cursor-pointer fs-4 logout-image"
                alt="logout" width="30" height="30" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <mat-menu #notificationmenu="matMenu" xPosition="before" class="panel-notify">
    <div *ngIf="authenticated">
      <div class="arrow-top"></div>
      <div class="notification-body p-2">
        <div class="d-flex flex-row justify-content-between align-items-center pe-2 ps-2">
          <h5 class="fs-16 color-Port-Gore text-capitalize fw-normal">
            {{ homeText?.notifications }}
          </h5>
        </div>
        <div class="notification-list-wrapper">
          <div class="notification-list" *ngIf="notficationsList?.length">
            <div class="notification-box p-1 cursor-pointer" (click)="handleNotificationClick(notificationPopUplist)"
              *ngFor="
                let notificationPopUplist of notficationsList;
                index as notificaitonIndex
              " [ngClass]="{
                'unread-notification':
                  notificationPopUplist?.is_viewed === false
              }">
              <div class="d-flex flex-row justify-content-start align-items-start pt-2 pb-2">
                <div class="user-icon p-1">
                  <ngx-avatar [name]="
                      notificationPopUplist?.posted_by_details?.full_name ||
                      notificationPopUplist?.posted_by_details?.username
                    " [bgColor]="notificaitonIndex | getRandomColor" size="38" [round]="true">
                  </ngx-avatar>
                </div>
                <div class="notification-msg d-flex flex-column p-1" matTooltip="{{ notificationPopUplist?.purpose }}">
                  <h5 class="color-black-olive fs-14 notification-header">
                    <span [ngClass]="{
                        'fw-bold': notificationPopUplist?.is_viewed === false,
                        'fw-normal': notificationPopUplist?.is_viewed !== false
                      }">
                      {{ notificationPopUplist?.purpose }}
                    </span>
                  </h5>
                  <span class="fs-12 color-black-olive fw-500 mb-0">
                    {{ notificationPopUplist?.posted_at | dateAgo }}
                  </span>
                </div>
                <div class="d-flex icon-container">
                  <mat-icon [ngClass]="
                      notificationPopUplist.is_flagged
                        ? 'important-flag'
                        : 'unimportant-flag'
                    " [ngStyle]="{
                      color: notificationPopUplist.is_flagged ? 'blue' : 'gray'
                    }" (click)="
                      $event.stopPropagation();
                      addOrRemoveFlag(
                        notificationPopUplist.id,
                        notificationPopUplist.is_flagged
                      )
                    ">flag</mat-icon>
                  <mat-icon class="delete-notification" (click)="
                      $event.stopPropagation();
                      deleteNotification(notificationPopUplist.id)
                    ">delete</mat-icon>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center my-4"
            *ngIf="!notficationsList?.length && !isNotificationActionLoading">
            <span class="text-capitalize text-dark text-center text-muted fs-18">{{ headerText?.no_notifications
              }}</span>
          </div>
          <div class="notification-loader-overlay" *ngIf="isNotificationActionLoading">
            <app-loading></app-loading>
          </div>
        </div>
        <div class="d-flex justify-content-center my-4" *ngIf="!notficationsList?.length">
          <span class="text-capitalize text-dark text-center text-muted fs-18">{{ headerText?.no_notifications }}</span>
        </div>
      </div>
    </div>
  </mat-menu>

  <ng-container *ngIf="showProfilePopUp && authenticated">
    <div class="log-container">
      <div class="arrow-top"></div>
      <div class="profile-body pt-4 p-2">
        <div class="d-flex flex-column cursor-pointer">
          <div class="p-1 border-bottom">
            <h5 class="color-Port-Gore fs-14">
              {{ headerText?.user_profile }}
            </h5>
          </div>
          <div class="pt-3 pb-3 border-bottom">
            <div class="d-flex flex-row justify-content-start align-items-start">
              <div class="user-icon p-1">
                <ngx-avatar [name]="user?.full_name" bgColor="#92c353" size="38" [round]="true">
                </ngx-avatar>
              </div>
              <div class="user-info d-flex flex-column p-1 mx-2">
                <h5 class="fs-16 text-dark">
                  {{ user?.full_name }}
                </h5>
                <p class="fs-14 fw-500 mb-0 text-dark mb-2 words-ellipse" data-bs-toggle="tooltip"
                  data-bs-placement="bottom" [title]="user?.email">
                  {{ user?.email }}
                </p>
              </div>
            </div>
          </div>
          <div class="pt-3 pb-3">
            <div class="d-flex flex-row justify-content-start align-items-center hover-box p-2"
              (click)="openChangePassword()" *ngIf="isDbLogin">
              <div class="pe-2 ps-2">
                <img src="../../../../assets/images/password.svg" alt="change password" width="18" height="18" />
              </div>
              <div class="pe-2 ps-2 text-capitalize">
                <p class="color-black-olive fs-16 fw-500 mb-0">
                  {{ headerText?.change_password }}
                </p>
              </div>
            </div>
            <div class="d-flex flex-row justify-content-start align-items-center hover-box p-2" (click)="logOut()">
              <div class="pe-2 ps-2">
                <img src="../../../../assets/images/header/logout.svg" alt="logout" width="18" height="18" />
              </div>
              <div class="pe-2 ps-2 text-capitalize">
                <p class="color-black-olive fs-16 fw-500 mb-0">
                  {{ headerText?.logout }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showLoginPopUp">
    <div class="login-container" id="login">
      <div class="arrow-top"></div>
      <div class="profile-body pt-1 p-1">
        <div class="d-flex flex-column cursor-pointer">
          <div class="pt-2 pb-1">
            <div class="d-flex flex-row justify-content-start align-items-center hover-box p-1" (click)="signIn()">
              <div class="pe-2 ps-2" style="color: white">
                <mat-icon aria-hidden="false" aria-label="material-icons-filled" class="cursor-pointer fs-4 me-2">
                  login
                </mat-icon>
              </div>
              <div class="pe-2 ps-2 text-capitalize">
                <p class="color-black-olive fs-16 fw-500 mb-0" style="color: white">
                  Sign In
                </p>
              </div>
            </div>
          </div>
          <div class="pt-1 pb-1">
            <div class="d-flex flex-row justify-content-start align-items-center hover-box p-1" (click)="signUp()">
              <div class="pe-2 ps-2" style="color: white">
                <img src="../../../../assets/images/signup.png" class="cursor-pointer fs-4 me-2" alt="logout" width="24"
                  height="24" />
              </div>
              <div class="pe-2 ps-2 text-capitalize">
                <p class="color-black-olive fs-16 fw-500 mb-0" style="color: white">
                  Sign Up
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>